import Vue from 'vue';
import plansModel from '../../models/plans';
import dateHelper from '../../helpers/dateFormats';
import app from '../../app';

const paymentClient = {
  namespaced: true,
  state: {
    isShowPaymentPage: false,
    isShowStudentsPage: false,
    isUpdatedFromApp: false,
    isShowUpgradePopup: false,
    upgradeData: {},
    currentSubscriptionPeriod: '',
    paymentHistory: [],
  },
  getters: {
    isShowPaymentPage: state => state.isShowPaymentPage,
    isShowStudentsPage: state => state.isShowStudentsPage,
    isUpdatedFromApp: state => state.isUpdatedFromApp,
    isShowUpgradePopup: state => state.isShowUpgradePopup,
    upgradeData: state => state.upgradeData,
    currentSubscriptionPeriod: state => state.currentSubscriptionPeriod,
    paymentHistory: state => state.paymentHistory,
  },
  mutations: {
    showPaymentPage(state, flag) {
      state.isShowPaymentPage = flag;
    },
    showStudentsPage(state, flag) {
      state.isShowStudentsPage = flag;
    },
    setUpdatingFlag(state, flag) {
      state.isUpdatedFromApp = flag;
    },
    showUpgradePopup(state, payload) {
      if (payload.show && plansModel.isCanNotBeUpdatedWithoutSales()) {
        app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form');

        return false;
      }

      const isAnnual = 'isAnnual' in payload ? payload.isAnnual : user.subscription.is_annual;

      state.isShowUpgradePopup = payload.show;
      state.upgradeData = { ...payload, isAnnual };
    },
    setCurrentSubscriptionPeriod(state, period) {
      state.currentSubscriptionPeriod = period;
    },
    setPaymentHistory(state, history) {
      state.paymentHistory = history;
    },
  },
  actions: {
    async fetchCurrentSubscriptionPeriod({ commit }) {
      const data = await webix.ajax().get(`${'/payment/plan' + '?'}${Date.now()}`);
      const subcsription = data.json();
      // const dateTo = plan.date_to ? dateHelper.formatDateNoTime(plan.date_to) : '';
      // const dateFrom = plan.date_from ? dateHelper.formatDateNoTime(plan.date_from) : '';

      const planPeriod = {
        dateFrom: subcsription.date_from,
        dateTo: subcsription.date_to,
      };

      commit('setCurrentSubscriptionPeriod', planPeriod);
    },
    async fetchPaymentHistory({ commit }) {
      const data = await webix.ajax().get(`${'/payment/history/' + '?'}${Date.now()}`);
      const history = data.json();

      const checkoutToPayproActions = {
        PAYMENT_AUTHORIZED: 'OrderCharged',
        COMPLETE: 'OrderCharged',
        REFUND: 'OrderRefunded',
      };

      const filteredHistory = [];

      history.map(item => {
        const details = JSON.parse(item.details);
        const gpn = JSON.parse(item.gpn);

        if (!gpn) {
          return;
        }

        if (gpn?.isSupendedAsTeamAlreadyHasNewSubscription) {
          return;
        }

        if (checkoutToPayproActions[item.action]) {
          item.action = checkoutToPayproActions[item.action];
        }
        const actionName = __(`common_type_action_${item.action}`);

        item.date = dateHelper.formatDateNoTime(item.date);
        item.invoiceLink = details.INVOICE_LINK;
        item.actionName = actionName;
        item.chargeFailed = false;
        item.order_total = gpn?.orderFullPriceUSD || 0;
        item.orderName = gpn.orderName;

        if (item.action === 'SubscriptionSuspended'
        || item.action === 'SubscriptionRenewed'
        || item.action === 'SubscriptionTerminated') {
          item.invoiceLink = null;
        }

        if (item.action === 'OrderRefunded') {
          item.order_total = Math.abs(gpn.orderRefundPriceUSD);
        }

        if (item.action === 'SubscriptionChargeFailed') {
          item.chargeFailed = true;
          item.invoiceLink = null;
        }

        filteredHistory.push(item);
      });
      const reversedHistory = filteredHistory.reverse();

      commit('setPaymentHistory', reversedHistory);
    },
    async subscriptionUpgrade({ dispatch }, nextPlan) {
      $$('mainApplication').showProgress({
        type: 'icon',
      });

      try {
        const updateResult = await plansModel.upgradePlan({
          nextPlan,
          provider: user.subscription.provider,
        });

        if (!updateResult.isUpgradeChargeRequired || updateResult.isUpgradeChargeWasSuccessfull) {
          dispatch('globalPopup/show', {
            type: 'thankUpgrade',
          }, { root: true });
        }

        $$('mainApplication').hideProgress();
      } catch (error) {
        Vue.$toast.error(__('error_while_payment_update'), { timeout: 10000 });
        $$('mainApplication').hideProgress();
        console.error(error);
      }
    },
    restoreSubscription({ }) {
      plansModel.renew(data => {
        if (data.isSuccess) {
          Vue.$toast.success(__('profile_successRenew'), { timeout: 10000 });
          user.team.status_code = 1;
          user.subscription.status_code = 1;
        } else {
          Vue.$toast.warning(__('profile_errorRenew'), { timeout: 10000 });
        }
      });
    },
  },
};

export default paymentClient;
